import React from 'react';
import clsx from 'clsx';

import { Preloader } from 'components/ui';

import styles from './PreloaderWrapper.module.scss';

type PreloaderWrapperProps = {
  className?: string;
}
export const PreloaderWrapper: React.FC<PreloaderWrapperProps> = ({ className }) => (
  <div className={clsx(styles.root, className)}>
    <Preloader />
  </div>
);
